import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { withRouter  } from 'react-router';
import DataGrid from '../components/datagrid/DataGrid';
import moment from 'moment';

const columns = [
    { id: 'ioId', label: 'Order' },
    { id: 'timeAgo', label: 'Pushed' },
    { id: 'placementCount', label: 'Count', filterable: true },
    { id: 'status', label: 'Job Status', filterable: true },
    { id: 'gamboJobId', label: 'Job ID',
        link: window.runConfig ? window.runConfig.REACT_APP_GAMBO_URL : `no Gambo URL /jobs/{gamboJobId}/results`, filterable: true },
    { id: 'errorText', label: 'Error Text', filterable: true },
];

class PushJobsGrid extends Component {

    state = {
        data: []
    };

    componentDidMount() {
        this.collectData();
    }

    componentDidUpdate(prevProps, prevState) {
      const {pushJobs} = this.props;
      if (prevState.data.length < pushJobs.length) {
          this.collectData();
      }
  }

  collectData () {
    const {pushJobs} = this.props;
    const data =  pushJobs.map((pj, i) => {
      if (typeof pj.pushParams === 'object'){
        pj.pushParams = JSON.stringify(pj.pushParams);
      }
      pj.placementIds = pj.placementIds.toString();
      pj.timeAgo = moment(pj.updatedAt).fromNow();
      pj.placementCount = pj.placementIds.length;
      return pj;
    });
    this.setState({data:data});
  }

  render() {
    const {data} = this.state;
    return (
      <DataGrid
        columns={columns}
        sortColumn="updatedAt"
        sortDirection="desc"
        data={data}
        title="Push Status"
        sortable
        filterable
        pagination
        showFilterRow
        selectable={false}
        offsetTop={110}
      />
    )
  }
}

PushJobsGrid.propTypes = {
  pushJobs: PropTypes.array.isRequired
};

export default withRouter(PushJobsGrid);
